import { useSubscription } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

import { Permission, useAuth, useCheckPermission } from '@/features/auth'

export function useFeedbacksSubscriptions() {
  const { isSignedIn, hasOrg } = useAuth()

  const canReadFeedback = useCheckPermission([Permission.FEEDBACK_READ])

  useSubscription(AdminAPI.simpleFeedback.CREATED, {
    variables: {
      withStay: true,
      withSpace: true
    },
    skip: !canReadFeedback || !isSignedIn || !hasOrg,
    onData({ data, client }) {
      if (!data.data) return

      const newFeedback = getFragment(
        SharedAPI.simpleFeedback.SIMPLE_FEEDBACK_FRAGMENT,
        data.data.simpleFeedbackCreated
      )

      client.cache.updateQuery(
        {
          query: AdminAPI.simpleFeedback.QUERY,
          variables: {
            page: 0,
            pageSize: 25,
            filter: {},
            withStay: true,
            withSpace: true
          }
        },
        data => {
          if (!data) return

          return {
            querySimpleFeedbacks: {
              ...data.querySimpleFeedbacks,
              // I have no idea how to fix the types here, I tried a lot nothing worked.
              // TODO: Maybe look into this again in the future, for now this seems to work
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              items: [newFeedback, ...data.querySimpleFeedbacks.items] as any
            }
          }
        }
      )

      if (!newFeedback.isRead) {
        client.cache.updateQuery(
          { query: AdminAPI.simpleFeedback.UNREAD_COUNT },
          data => {
            if (!data) return

            return {
              unreadFeedbackCount: data.unreadFeedbackCount + 1
            }
          }
        )
      }
    }
  })

  useSubscription(AdminAPI.simpleFeedback.MARKED_READ, {
    skip: !canReadFeedback || !isSignedIn || !hasOrg,
    onData({ data, client }) {
      if (!data.data) return

      const { ids, userId } = data.data.simpleFeedbackMarkedRead

      client.cache.updateQuery(
        {
          query: AdminAPI.simpleFeedback.QUERY,
          variables: {
            page: 0,
            pageSize: 25,
            filter: {},
            withStay: true,
            withSpace: true
          }
        },
        data => {
          if (!data) return

          return {
            querySimpleFeedbacks: {
              ...data.querySimpleFeedbacks,
              items: data.querySimpleFeedbacks.items.map(function (item) {
                if (item.isRead) return item
                if (!ids.includes(item.id)) return item
                if (item.isRead) return item

                return {
                  ...item,
                  isRead: true,
                  readByUserId: userId,
                  readAt: new Date().toISOString()
                }
              })
            }
          }
        }
      )

      client.cache.updateQuery(
        { query: AdminAPI.simpleFeedback.UNREAD_COUNT },
        data => {
          if (!data) return

          return {
            unreadFeedbackCount: Math.max(
              0,
              data.unreadFeedbackCount - ids.length
            )
          }
        }
      )
    }
  })
}
